import type {
  ExperienceProfile,
  ExperienceDefaults,
  ExperienceBinding,
} from '@nava/backoffice-bff-contracts';
import { ExperienceProfileSelection } from './ExperienceProfileSelection';
interface Props {
  profiles: ExperienceProfile[];
  defaults: ExperienceDefaults | undefined;
  study: string | null;
  binding: ExperienceBinding | undefined;
  busy: boolean;
  publishDisabled?: boolean;
  onDefault: (line: 'insights' | 'customer_success', id: string | null) => void;
  onBinding: (id: string | null) => void;
  onPublish: () => void;
}
export function ExperienceAssignments({
  profiles,
  defaults,
  study,
  binding,
  busy,
  onDefault,
  onBinding,
  onPublish,
  publishDisabled,
}: Props) {
  return (
    <>
      {study && binding && (
        <section className="space-y-3 rounded-xl border bg-white p-5">
          <h2 className="font-semibold">Study selection</h2>
          <ExperienceProfileSelection
            label="Participant experience"
            value={binding.profileId}
            profiles={profiles}
            disabled={busy}
            onChange={onBinding}
          />
          <p className="text-sm">
            The selection is saved to the draft. Apply it to the live study when ready; existing
            sessions keep their wording.
          </p>
          <button
            disabled={busy || publishDisabled}
            className="rounded bg-violet-700 px-4 py-2 text-white"
            onClick={onPublish}
          >
            Apply to live study
          </button>
        </section>
      )}
      {defaults && (
        <section className="space-y-3 rounded-xl border bg-white p-5">
          <h2 className="font-semibold">Defaults for new studies</h2>
          <p className="text-sm">Changing these defaults does not change existing studies.</p>
          {(['insights', 'customer_success'] as const).map((line) => (
            <ExperienceProfileSelection
              key={line}
              label={line === 'insights' ? 'Insights' : 'Customer Success'}
              value={defaults[line]}
              profiles={profiles}
              disabled={busy}
              onChange={(id) => onDefault(line, id)}
            />
          ))}
        </section>
      )}
    </>
  );
}
